import { FormWidget } from '@cian/frontend-request-form-widget';
import * as React from 'react';
import { FORM_COMPONENTS, FIELD_MAPPER_EXTENSION, TOPIC_STEP, SCHEMA, SKIP_STEPS } from '../../mappers/requestForm';
import { useFormContainer } from './hooks/useFormContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export var FormContainer = function FormContainer() {
  var _useFormContainer = useFormContainer(),
    formKey = _useFormContainer.formKey,
    formInitialState = _useFormContainer.formInitialState,
    handleSubmit = _useFormContainer.handleSubmit,
    handleNextStep = _useFormContainer.handleNextStep,
    handleCrackedNextStepCondition = _useFormContainer.handleCrackedNextStepCondition;
  return /*#__PURE__*/_jsx(FormWidget, {
    initialFormValue: formInitialState,
    firstStepCode: TOPIC_STEP.code,
    skipSteps: SKIP_STEPS,
    stepsSchema: SCHEMA,
    components: FORM_COMPONENTS,
    fieldMapperExtension: FIELD_MAPPER_EXTENSION,
    onSubmit: handleSubmit,
    onNextStep: handleNextStep,
    onCrackedNextStepCond: handleCrackedNextStepCondition
  }, formKey);
};